// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-container img {
  height: auto;
  width: 90%;
}

.about_home .col-lg-8 {
  background: rgba(195 197 248 / 20%);
  /* opacity: 0.8; */
  border-radius: 30px;
  padding: 0px 40px;
  text-align: left;
  /* padding-bottom: 50px; */
}

.about_home_heading {
  font-family: "Poppins";
  font-weight: 700;
  font-size: 36px;
  line-height: 70px;
  /* letter-spacing: 0.06em; */
  color: #264ec8;
  margin-top: 45px;
}

.about_home_heading span,
.about_home h2 {
  color: var(--dPink);
}

.about_home_para {
  font-size: var(--pSize);
  letter-spacing: 0.06em;
  color: #112f48;
}

.about_home_para.f-18 {
  font-size: 18px;
}

.about_home_counter_cont {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}
.about_home_counter_item p {
  color: #264ec8;
  text-align: center;
  padding: 0px 10px;
}

.about_home_counter_item h2 {
  font-size: 50px;
  font-weight: 900;
  text-align: center;
}
.about_home_counter_item h2 p {
  font-size: var(--sHsize);
}
.about_home video {
  object-fit: cover;
  border-radius: 30px;
}
.about_home_counter_item {
  color: #ff289c;
}
.video-container {
  position: relative;
}
.play-icon {
  color: #ffffff;
}
/* .play-button-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.7;
  animation: blink 1.5s infinite;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
} */
.pulse {
  position: absolute;
  width: 100px;
  height: 100px;
  background: var(--dPink);
  border-radius: 50%;
  color: #fff;
  font-size: 20px;
  text-align: center;
  line-height: 100px;
  font-family: sans-serif;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-transform: uppercase;
  animation: animate-pulse 3s linear infinite;
  cursor: pointer;
}
@keyframes animate-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 109, 74, 0.7), 0 0 0 0 rgba(255, 109, 74, 0.7);
  }
  40% {
    box-shadow: 0 0 0 50px rgba(255, 109, 74, 0),
      0 0 0 0 rgba(255, 109, 74, 0.7);
  }
  80% {
    box-shadow: 0 0 0 50px rgba(255, 109, 74, 0),
      0 0 0 30px rgba(255, 109, 74, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 109, 74, 0), 0 0 0 30px rgba(255, 109, 74, 0);
  }
}
@media (max-width: 576px) {
  .about_home_heading {
    margin-top: 0px;
  }
  .about_home .col-lg-8 {
    padding: 30px 20px;
    border-radius: 15px;
    margin-top: 15px;
  }
  .about_home video {
    border-radius: 15px;
  }
  .about_home a {
    display: block;
    margin: 0 auto;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    font-size: var(--pSize);
    text-decoration: none;
  }
  .about_home_counter_cont {
    flex-wrap: wrap;
  }
  .about_home_counter_item {
    width: 50%;
  }
}
@media only screen and (min-width: 576px) and (max-width: 992px) {
  .video-container img {
    height: 300px;
    object-fit: cover;
    width: 100%;
    border-radius: 25px;
    margin-bottom: 25px;
  }
}

@media only screen and (min-width: 1080px) and (max-width: 1200px) {
  .about_home_heading {
    line-height: 40px;
    margin-top: 15px;
  }

  .about_home_counter_cont {
    margin: 0;
    margin: initial;
  }

  .about_home_counter_item h2 {
    font-size: 28px;
  }

  .about_home .col-lg-8 {
    padding: 5px 20px;
  }

  .video-container img {
    height: 440px;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/home/about.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;;;;;;;;;;;;;;;;;;;GAmBG;AACH;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EAEzB,2CAA2C;EAC3C,eAAe;AACjB;AACA;EACE;IACE,4EAA4E;EAC9E;EACA;IACE;qCACiC;EACnC;EACA;IACE;sCACkC;EACpC;EACA;IACE,2EAA2E;EAC7E;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,cAAc;IACd,0BAAkB;IAAlB,uBAAkB;IAAlB,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,SAAa;IAAb,eAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;AACF","sourcesContent":[".video-container img {\r\n  height: auto;\r\n  width: 90%;\r\n}\r\n\r\n.about_home .col-lg-8 {\r\n  background: rgba(195 197 248 / 20%);\r\n  /* opacity: 0.8; */\r\n  border-radius: 30px;\r\n  padding: 0px 40px;\r\n  text-align: left;\r\n  /* padding-bottom: 50px; */\r\n}\r\n\r\n.about_home_heading {\r\n  font-family: \"Poppins\";\r\n  font-weight: 700;\r\n  font-size: 36px;\r\n  line-height: 70px;\r\n  /* letter-spacing: 0.06em; */\r\n  color: #264ec8;\r\n  margin-top: 45px;\r\n}\r\n\r\n.about_home_heading span,\r\n.about_home h2 {\r\n  color: var(--dPink);\r\n}\r\n\r\n.about_home_para {\r\n  font-size: var(--pSize);\r\n  letter-spacing: 0.06em;\r\n  color: #112f48;\r\n}\r\n\r\n.about_home_para.f-18 {\r\n  font-size: 18px;\r\n}\r\n\r\n.about_home_counter_cont {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 40px;\r\n}\r\n.about_home_counter_item p {\r\n  color: #264ec8;\r\n  text-align: center;\r\n  padding: 0px 10px;\r\n}\r\n\r\n.about_home_counter_item h2 {\r\n  font-size: 50px;\r\n  font-weight: 900;\r\n  text-align: center;\r\n}\r\n.about_home_counter_item h2 p {\r\n  font-size: var(--sHsize);\r\n}\r\n.about_home video {\r\n  object-fit: cover;\r\n  border-radius: 30px;\r\n}\r\n.about_home_counter_item {\r\n  color: #ff289c;\r\n}\r\n.video-container {\r\n  position: relative;\r\n}\r\n.play-icon {\r\n  color: #ffffff;\r\n}\r\n/* .play-button-overlay {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  opacity: 0.7;\r\n  animation: blink 1.5s infinite;\r\n}\r\n\r\n@keyframes blink {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  50% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n} */\r\n.pulse {\r\n  position: absolute;\r\n  width: 100px;\r\n  height: 100px;\r\n  background: var(--dPink);\r\n  border-radius: 50%;\r\n  color: #fff;\r\n  font-size: 20px;\r\n  text-align: center;\r\n  line-height: 100px;\r\n  font-family: sans-serif;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  text-transform: uppercase;\r\n  -webkit-animation: animate-pulse 3s linear infinite;\r\n  animation: animate-pulse 3s linear infinite;\r\n  cursor: pointer;\r\n}\r\n@keyframes animate-pulse {\r\n  0% {\r\n    box-shadow: 0 0 0 0 rgba(255, 109, 74, 0.7), 0 0 0 0 rgba(255, 109, 74, 0.7);\r\n  }\r\n  40% {\r\n    box-shadow: 0 0 0 50px rgba(255, 109, 74, 0),\r\n      0 0 0 0 rgba(255, 109, 74, 0.7);\r\n  }\r\n  80% {\r\n    box-shadow: 0 0 0 50px rgba(255, 109, 74, 0),\r\n      0 0 0 30px rgba(255, 109, 74, 0);\r\n  }\r\n  100% {\r\n    box-shadow: 0 0 0 0 rgba(255, 109, 74, 0), 0 0 0 30px rgba(255, 109, 74, 0);\r\n  }\r\n}\r\n@media (max-width: 576px) {\r\n  .about_home_heading {\r\n    margin-top: 0px;\r\n  }\r\n  .about_home .col-lg-8 {\r\n    padding: 30px 20px;\r\n    border-radius: 15px;\r\n    margin-top: 15px;\r\n  }\r\n  .about_home video {\r\n    border-radius: 15px;\r\n  }\r\n  .about_home a {\r\n    display: block;\r\n    margin: 0 auto;\r\n    width: fit-content;\r\n    font-size: var(--pSize);\r\n    text-decoration: none;\r\n  }\r\n  .about_home_counter_cont {\r\n    flex-wrap: wrap;\r\n  }\r\n  .about_home_counter_item {\r\n    width: 50%;\r\n  }\r\n}\r\n@media only screen and (min-width: 576px) and (max-width: 992px) {\r\n  .video-container img {\r\n    height: 300px;\r\n    object-fit: cover;\r\n    width: 100%;\r\n    border-radius: 25px;\r\n    margin-bottom: 25px;\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 1080px) and (max-width: 1200px) {\r\n  .about_home_heading {\r\n    line-height: 40px;\r\n    margin-top: 15px;\r\n  }\r\n\r\n  .about_home_counter_cont {\r\n    margin: unset;\r\n  }\r\n\r\n  .about_home_counter_item h2 {\r\n    font-size: 28px;\r\n  }\r\n\r\n  .about_home .col-lg-8 {\r\n    padding: 5px 20px;\r\n  }\r\n\r\n  .video-container img {\r\n    height: 440px;\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
